import { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import Allocation from './components/Allocation';
import Loyalti from './components/Loyalti';
import Perks from './components/Perks';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RefCode } from './helpers';
import AppRouter from './routes/AppRouter';
import { Link, useLocation, useRoutes } from 'react-router-dom';
import { ethers } from 'ethers';
import { useAccount } from 'wagmi';
import { defaultProvider, getBuyTokenContract } from './helpers/web3utils';
function App() {
  let location = useLocation();
  const [t, setT] = useState(false);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref && ethers.isAddress(ref)) RefCode.set(ref);
  }, []);
  return (
    <div className="App">
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        theme="dark"
        toastStyle={{ background: '#2E2E2E' }}
      />
      <div className="container mx-auto">
        <Header setT={setT} t={t} />
        {/* <HeaderMobile /> */}
        <main>
          <div className="p-presale">
            <div className="inner">
              <div className="p-presale-box">
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 8
                  }}
                >
                  <ul className="p-presale-head js-tab">
                    <li
                      className={`p-presale-head__item  ${location.pathname === '/' ? 'active' : location.pathname.startsWith('/ref/') ? 'active' : ''}`}
                    >
                      <Link to="/">Allocation</Link>
                    </li>
                    <li
                      className={`p-presale-head__item  ${location.pathname === '/referral' ? 'active' : ''}`}
                    >
                      <Link to="/referral">Referrals</Link>
                    </li>
                  </ul>
                  <div className="wallet-net-worth">
                    Wallet Net Worth:{' '}
                    <span>
                      <span className="p-presale-area__sub">
                        <WalletNetWorth t={t} />
                      </span>{' '}
                      BNB
                    </span>
                  </div>
                </div>
                <div className="p-presale-body">
                  <AppRouter setT={setT} />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;

const WalletNetWorth = ({ t }) => {
  const [total, setTotal] = useState(0);
  const { address, isConnected } = useAccount();
  useEffect(() => {
    if (isConnected) {
      init();
    } else {
      setTotal(0);
    }
  }, [isConnected, t]);
  const init = async () => {
    var contract = getBuyTokenContract();
    contract = contract.connect(defaultProvider());
    const totalRef = await contract.totalClaimRef(address);
    const totalBuy = await contract.totalBuy(address);
    // eslint-disable-next-line no-undef
    const currentPrice = await contract.getCurrentPrice(BigInt(0));
    const t =
      (Number(ethers.formatEther(totalBuy)) + Number(ethers.formatEther(totalRef))) *
      Number(ethers.formatEther(currentPrice));
    setTotal(t);
  };
  return <>{total.toFixed(4)}</>;
};
